import type { ClavePaso, GrupoPaso, PasoPuestaEnMarcha, PuestaEnMarcha } from "@/lib/api";

/** Título y ruta de cada paso (el estado y el orden los da el backend). */
export const PASOS: Record<ClavePaso, { titulo: string; ruta: string }> = {
  fideicomiso: { titulo: "Datos del fideicomiso", ruta: "/configuracion/fideicomiso" },
  fiduciario: { titulo: "Fiduciario", ruta: "/configuracion/fideicomiso" },
  fiduciantes: { titulo: "Fiduciantes y participación", ruta: "/fiduciantes" },
  ubicacion: { titulo: "Ubicación", ruta: "/terreno" },
  compra: { titulo: "Compra", ruta: "/terreno" },
  documentacion: { titulo: "Escritura y boleto", ruta: "/terreno" },
  unidades: { titulo: "Unidades", ruta: "/unidades" },
  presupuesto: { titulo: "Presupuesto", ruta: "/presupuesto" },
  cronograma: { titulo: "Cronograma de obra", ruta: "/cronograma" },
};

/** Las tres tarjetas del Inicio: el desarrollo nace del fideicomiso y el terreno; la obra viene después. */
export const GRUPOS: Record<GrupoPaso, { titulo: string; descripcion: string }> = {
  fideicomiso: { titulo: "Fideicomiso", descripcion: "Los datos legales, el fiduciario y quiénes aportan." },
  terreno: { titulo: "Terreno", descripcion: "Dónde está, la compra y la escritura." },
  obra: { titulo: "Obra", descripcion: "Qué se construye, cuánto cuesta y cuándo." },
};

const ORDEN_GRUPOS: GrupoPaso[] = ["fideicomiso", "terreno", "obra"];

export interface GrupoPuestaEnMarcha {
  clave: GrupoPaso;
  titulo: string;
  descripcion: string;
  pasos: PasoPuestaEnMarcha[];
  completos: number;
  total: number;
  completo: boolean;
  /** La obra espera a que el fideicomiso y el terreno estén completos: se ve apagada, pero los links andan. */
  enEspera: boolean;
}

export function agruparPasos(estado: PuestaEnMarcha): GrupoPuestaEnMarcha[] {
  const grupos = ORDEN_GRUPOS.map((clave) => {
    const pasos = estado.pasos.filter((p) => p.grupo === clave);
    const completos = pasos.filter((p) => p.completo).length;
    return { clave, ...GRUPOS[clave], pasos, completos, total: pasos.length, completo: completos === pasos.length, enEspera: false };
  });
  const base = grupos.filter((g) => g.clave !== "obra").every((g) => g.completo);
  return grupos.map((g) => (g.clave === "obra" ? { ...g, enEspera: !base } : g));
}

export function tituloPuestaEnMarcha(estado: PuestaEnMarcha): string {
  return `Puesta en marcha · ${estado.completos} de ${estado.total}`;
}

export type Plegado = "abierto" | "plegado";

/** Abierto mientras falte algo, plegado cuando está todo completo; si el admin lo plegó o abrió a mano, eso manda. */
export function abiertoInicial(estado: PuestaEnMarcha, guardado: Plegado | null): boolean {
  if (guardado) return guardado === "abierto";
  return !estado.completa;
}

const clave = (fid: number) => `matsu.puesta-en-marcha.${fid}`;

export function leerPlegado(fid: number): Plegado | null {
  try {
    const v = window.localStorage.getItem(clave(fid));
    return v === "abierto" || v === "plegado" ? v : null;
  } catch {
    return null;
  }
}

export function guardarPlegado(fid: number, abierto: boolean): void {
  try {
    window.localStorage.setItem(clave(fid), abierto ? "abierto" : "plegado");
  } catch {
    // modo privado o storage bloqueado: se pierde la elección al recargar, nada más
  }
}
